export const moneyFormat = (amount: number, decimal?: number) => {
  const formatted = amount
    .toFixed(!isNaN(decimal) && typeof decimal != undefined ? decimal : 4)
    .replace(/\.?0+$/, "")
  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
